import styled from "styled-components";
import nativeStyle from "styled-components/native";
import { Dimensions } from "react-native";

const evalString = (value) => {
  switch (value && value.toLowerCase()) {
    case "true":
      return true;
    case "false":
      return false;
    default:
      return value;
  }
};

export const Container = styled.section`
  display: flex;
  flex: 1;
  background-color: ${(props) =>
    evalString(props.questionAnswer)
      ? "var(--background-color-default)"
      : "#575f69"};
  flex-direction: column;
  margin-top: -26px;
`;

export const TopSection = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: flex-end;
  text-align: center;
`;

export const Text = styled.div`
  color: ${(props) =>
    evalString(props.questionAnswer)
      ? "var(--knowledge-answers-true-color)"
      : "#ffffff"};
  font-size: ${(props) => props.fontSize || 24}px;
  font-weight: var(--font-weight-bold);
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  text-shadow: 0 1px 0 rgba(0, 0, 0, 0.15);
  letter-spacing: ${(props) => props.letterSpacing || 2.34}px;
  text-align: center;
  margin-top: ${(props) => props.marginTop || 0}px;
`;

export const Question = styled.div`
  color: ${(props) =>
    evalString(props.questionAnswer)
      ? "var(--knowledge-answers-true-color)"
      : "#ffffff"};
  font-size: ${Dimensions.get("screen").width <= 320 ? "20px" : "24px"};
  font-weight: var(--font-weight-light);
  letter-spacing: 2.4px;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  margin-top: ${Dimensions.get("screen").width <= 320 ? "20px" : "15px"};
`;

export const BottomSection = styled.div`
  display: flex;
  flex: 1;
`;

export const BottomSectionWrapper = styled.div`
  display: flex;
  flex: 1;
  justify-content: ${(props) => props.justifyContent || ""};
  flex-direction: ${(props) => props.flexDirection || ""};
`;

export const Rectangle = nativeStyle.TouchableOpacity`
  display: flex;
  flex: 1;
  flex-direction: column;
  opacity: ${(props) => (props.touched ? "0.5" : "1")};
  background-image: ${(props) =>
    evalString(props.questionAnswer)
      ? `var(--knowledge-confidence-true-linear-gradient)`
      : `var(--knowledge-confidence-false-linear-gradient)`};
  }
`;
